import { styled } from 'stitches.config'

export const Background = styled('div', {
  position: 'relative',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
})

export const IconContainer = styled('div', {
  position: 'absolute',
})

export const TextContainer = styled('div', {
  position: 'absolute',
  top: '158px',
  color: '$accent-black',
  maxWidth: '280px',
})

export const BlobTitleRoot = styled('div', {
  order: 0,
  paddingTop: '$6',
  margin: '0 auto',

  '@bp2': {
    paddingTop: '$8',
    paddingBottom: '$6',
  },

  variants: {
    variant: {
      foodForDigestiveIssues: {
        [`& ${Background}`]: {
          width: '327px',
          height: '384px',

          '@bp2': {
            width: '470px',
            height: '552px',
          },
        },

        [`& ${TextContainer}`]: {
          left: '$6',
          '@bp2': {
            left: '153px',
          },
        },

        [`& ${IconContainer}`]: {
          top: '30px',
          left: '$7',

          '@bp2': {
            left: '135px',
          },
        },
      },

      foodForDogsWithAllergies: {
        [`& ${Background}`]: {
          width: '327px',
          height: '331px',

          '@bp2': {
            width: '470px',
            height: '478px',
          },
        },

        [`& ${TextContainer}`]: {
          left: '$10',
          top: '$12',

          '@bp2': {
            left: '153px',
          },
        },

        [`& ${IconContainer}`]: {
          top: '-$3',
          left: '$15',

          '@bp2': {
            left: '135px',
          },
        },
      },

      coatHealth: {
        [`& ${Background}`]: {
          width: '327px',
          height: '342px',

          '@bp2': {
            width: '566px',
            height: '593px',
          },
        },

        [`& ${TextContainer}`]: {
          left: '$5',
          top: '$13',

          '@bp2': {
            left: '$14',
            top: '144px',
          },
        },

        [`& ${IconContainer}`]: {
          top: '0',
          left: '$15',

          '@bp2': {
            left: '$14',
          },
        },
      },

      foodForUrinaryHealth: {
        [`& ${Background}`]: {
          width: '327px',
          height: '358px',

          '@bp2': {
            width: '418px',
            height: '458px',
          },
        },

        [`& ${TextContainer}`]: {
          left: '$7',
          top: '$12',

          '@bp2': {
            left: '$14',
            top: '$15',
          },
        },

        [`& ${IconContainer}`]: {
          top: '-$3',
          left: '$15',

          '@bp2': {
            left: '$14',
            top: 0,
          },
        },
      },

      foodForWeightLoss: {
        [`& ${Background}`]: {
          width: '327px',
          height: '332px',

          '@bp2': {
            width: '418px',
            height: '424px',
          },
        },

        [`& ${TextContainer}`]: {
          left: '$7',
          top: '$12',

          '@bp2': {
            left: '$14',
            top: '$15',
          },
        },

        [`& ${IconContainer}`]: {
          top: '-$3',
          left: '$15',

          '@bp2': {
            left: '$14',
            top: 0,
          },
        },
      },

      pickyEaters: {
        [`& ${Background}`]: {
          width: '327px',
          height: '285px',

          '@bp2': {
            width: '418px',
            height: '364px',
          },
        },

        [`& ${TextContainer}`]: {
          left: '$7',
          top: '$12',

          '@bp2': {
            left: '$14',
            top: '$15',
          },
        },

        [`& ${IconContainer}`]: {
          top: '-$3',
          left: '$15',

          '@bp2': {
            left: '$14',
            top: 0,
          },
        },
      },
    },
  },
})
